import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { PropTypes } from "prop-types";
import { ContentImpl } from "./content.styles.es.js";
import "@reach/auto-id";
import "lodash/fp";
import { useColorScheme } from "../../hooks/use-color-scheme.es.js";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
const propTypes = {
  alignX: PropTypes.oneOf(["left", "center", "right", "stretch"]),
  background: PropTypes.oneOf([
    "black",
    "blue",
    "gray",
    "green",
    "red",
    "transparent",
    "white",
    "yellow"
  ]),
  border: PropTypes.bool,
  borderBottom: PropTypes.bool,
  borderLeft: PropTypes.bool,
  borderRadiusPlacement: PropTypes.oneOf([
    "all",
    "bottom",
    "bottomLeft",
    "bottomRight",
    "left",
    "right",
    "topLeft",
    "topRight"
  ]),
  borderRadiusSize: PropTypes.oneOf(["none", "small", "large"]),
  borderRight: PropTypes.bool,
  borderTop: PropTypes.bool,
  children: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  overflow: PropTypes.oneOf(["scroll", "visible"]),
  padding: PropTypes.oneOf([
    "none",
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge"
  ]),
  paddingMode: PropTypes.oneOf(["equal", "extended"]),
  shadow: PropTypes.bool,
  sizing: PropTypes.oneOf(["auto", "fill-container", "fit-content"]),
  textAlign: PropTypes.oneOf(["left", "center", "right", "justify"]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
const defaultProps = {
  alignX: void 0,
  background: "transparent",
  border: false,
  borderBottom: void 0,
  borderLeft: void 0,
  borderRadiusSize: "none",
  borderRadiusPlacement: "all",
  borderRight: void 0,
  borderTop: void 0,
  children: void 0,
  height: void 0,
  maxHeight: void 0,
  maxWidth: "100%",
  minHeight: void 0,
  minWidth: void 0,
  overflow: "visible",
  padding: "none",
  paddingMode: "extended",
  shadow: false,
  sizing: "auto",
  textAlign: void 0,
  width: void 0
};
const Content = forwardRef(
  ({
    alignX,
    background,
    border,
    borderBottom,
    borderLeft,
    borderRadiusSize,
    borderRadiusPlacement,
    borderRight,
    borderTop,
    children,
    height,
    maxHeight,
    maxWidth,
    minHeight,
    minWidth,
    overflow,
    padding,
    paddingMode,
    shadow,
    sizing,
    textAlign,
    width
  }, ref) => {
    const { backgroundColor, borderColor, textColor } = useColorScheme(background);
    return /* @__PURE__ */ jsx(
      ContentImpl,
      {
        ref,
        $alignX: alignX,
        $backgroundColor: backgroundColor,
        $borderBottom: borderBottom ?? border,
        $borderRadiusPlacement: borderRadiusPlacement,
        $borderRadiusSize: borderRadiusSize,
        $borderColor: borderColor,
        $borderLeft: borderLeft ?? border,
        $borderRight: borderRight ?? border,
        $borderTop: borderTop ?? border,
        $height: height,
        $maxHeight: maxHeight,
        $maxWidth: maxWidth,
        $minHeight: minHeight,
        $minWidth: minWidth,
        $overflow: overflow,
        $padding: padding,
        $paddingMode: paddingMode,
        $shadow: shadow,
        $sizing: sizing,
        $textAlign: textAlign,
        $textColor: textColor,
        $width: width,
        children
      }
    );
  }
);
Content.propTypes = propTypes;
Content.defaultProps = defaultProps;
export {
  Content
};
